import { FormControl, FormGroup } from "@angular/forms";
import { SelectionOption } from "../shared";
import { EmailAttachment } from "./case-communication-drawer.model";
import { PlaceholderOption } from "./placeholder-option.model";

export interface SendNewEmailDialog {
	relevantRecipientOptions: SelectionOption[]; // includes relevant context and email address type
	employeeRecipientOptions: SelectionOption[]; // includes email address type
	templateOptions: TemplateOption[];
	placeholderOptions: PlaceholderOption[];
	sender: SelectionOption; // includes email address type
	automaticCcAddresses: string[]; //nullable
	automaticBccAddresses: string[]; //nullable
}

export interface TemplateOption {
	id: number;
	description: string;
}

export interface GetSendNewEmailTemplateDetails {
	caseId: number;
	templateId: number;
}

export interface SendNewEmailTemplateDetails {
	subjectText: string;
	bodyHtml: string;
	attachments: EmailAttachment[]; //nullable
}

export interface PostSendNewEmail {
	caseId: number;

	to: Recipients;
	subject: string;

	cc: Recipients;
	bcc: Recipients;

	bodyText: string;
	body: string;
	bodyBlob: Blob;

	templateAttachmentIds: number[];
	userAttachmentFiles: File[];
}

export interface SendAttachment {
	isTemplateFile: boolean;
	attachmentId?: number;
	file: File;
}

export interface EmployeeRecipient {
	employeeId: number;
	emailAddressTypeId: number;
}

export interface RelevantRecipient {
	employeeId: number;
	emailAddressTypeId: number;
	relevantContextId: number;
}

export interface Recipients {
	relevantRecipients: RelevantRecipient[];
	employeeRecipients: EmployeeRecipient[];
	emailAddresses: string[];
}

export interface EmailPreviewPost {
	caseId: number
	// encode subject/body as base 64 to get around AFD WAF
	subjectBytes: string //byte[]
	bodyBytes: string //byte[]
}

export interface EmailPreview {
	caseId: number
	subject: string
	bodyHtml: string
}

export interface SendNewEmailForm {
	templates: FormControl<number>
	to: FormGroup;
	cc: FormGroup;
	bcc: FormGroup;
	subject: FormControl<string>;
	body: FormControl<string>;
}

export interface RecipientsFormGroup {
	relevantRecipientOptions:  FormControl<string[]>;
	employeeRecipientOptionAdd:  FormControl<string>;
	employeeRecipientOptions:  FormControl<string[]>;
	additionalEmailAddressAdd:  FormControl<string>;
	additionalEmailAddresses:  FormControl<string[]>;
	recipientBoxChips: FormControl<RecipientBoxChip[]>;
}

export enum ChipType {
  RelevantRecipient = 1,
  Contact = 2,
  AdditionalEmail = 3
}

export enum RecipientsGroup {
  to = 1,
  cc = 2,
  bcc = 3
}

export interface RecipientBoxChip {
	id: number;
	description: string;
	emailAddress: string;
	emailAddressTypeId: number;
	relevantContextId: number;
	type: ChipType;
}